module.exports = __webpack_public_path__ + "img/my-account-desktop-en.2a02d77e.jpg";